import { createFileRoute } from "@tanstack/react-router";
import { LocalizationListPage } from "../../../components/system/LocalizationListPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/localization/")({
  beforeLoad: requireSuperAdmin(),
  component: LocalizationRoute,
});

function LocalizationRoute() {
  return <LocalizationListPage />;
}
